import React from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";
import parse from "html-react-parser";

const EmbedFormTemplateHeader = ({
  includeTitleAndDesc,
  displayImageForm,
  formImage,
  displayTitleForm,
  formTitle,
  displayDescriptionForm,
  formDescription,
}) => {
  const { getTextByKey } = useContent();
  return (
    <div className="embed-dynamic-details">
      {includeTitleAndDesc !== false ? (
        <div className="form-details-template">
          {formImage && displayImageForm && (
            <div className="form-image-template">
              <Image alt="" title="" src={formImage} />
            </div>
          )}
          <div
            className={`form-content-template ${
              !formImage || !displayImageForm ? "full-width" : ""
            }`}
          >
            <div className={`content-form-div-template`}>
              {displayTitleForm && (
                <h2 title={formTitle.length > 20 ? parse(formTitle) : ""}>
                  {parse(formTitle)}
                </h2>
              )}
              {displayDescriptionForm && formDescription ? (
                formDescription.length > 80 ? (
                  <Tooltip
                    id="full-description-form"
                    tooltipText={parse(formDescription)}
                    bottom
                    hardPositionedPosition
                    //hardPositioned={true}
                  >
                    <span className="description-text">
                      {parse(formDescription)}
                    </span>
                  </Tooltip>
                ) : (
                  <span className="description-text">
                    {parse(formDescription)}
                  </span>
                )
              ) : null}
            </div>
          </div>
        </div>
      ) : (
        <span className="fill-form-text">
          {getTextByKey("fill-embed-form-text")}
        </span>
      )}
    </div>
  );
};

export default EmbedFormTemplateHeader;
